<template>
  <Component
    v-if="db"
    :to="'/database/' + db.id"
    :is="tag"
    class="jps-db-span"
    :nolink="nolink || !db"
  >
    <slot :db="db">{{ ls(db?.name) }}</slot>
  </Component>
</template>

<script lang="ts" setup>
import BaseLink from '~/components/base/BaseLink.vue'

interface Props {
  id: string
  tag?: string | Component
  nolink?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  tag: () => BaseLink,
  nolink: true,
})

const dataStore = useDataStore()
const db = computed(() => dataStore.database(props.id))
const { ls } = useI18n()
</script>

<style lang="scss" scoped>
  .jps-db-span {
    overflow-wrap: anywhere;
    white-space: wrap;
  }
</style>